import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import Vue from 'vue'

// initial state
const state = {
  couleurstrafen: [],
  loading: false,
  error: null
}

// getters
const getters = {
  couleurstrafen (state) {
    return state.couleurstrafen
  },
  couleurstrafenKasse: (state) => (kasse) => {
    let couleurstrafen = []
    state.couleurstrafen.forEach(couleurstraf => {
      if (couleurstraf.kasse === kasse) {
        couleurstrafen.push(couleurstraf)
      }
    })
    return couleurstrafen
  },
  couleurstraf: (state) => (id) => {
    return state.couleurstrafen.find(couleurstraf => couleurstraf.id === id)
  },
  loading (state) {
    return state.loading
  },
  error (state) {
    return state.error
  }
}

// actions
const actions = {
  loadCouleurstrafen ({commit}) {
    commit('setLoading', true)
    console.log('Couleurstrafen laden...')
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('couleurstrafen').orderBy('datum', 'desc').get()
    .then(snapshot => {
      const couleurstrafen = []
      snapshot.forEach(doc => {
        couleurstrafen.push({
          ...doc.data(),
          id: doc.id
        })
        commit('setLoadedCouleurstrafen', couleurstrafen)
        commit('setLoading', false)
      })
    })
    .catch(
      (error) => {
        console.log(error)
        commit('setLoading', false)
      }
    )
  },
  createCouleurstraf ({commit, getters}, payload) {
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('couleurstrafen').add(payload)
      .then(key => {
        commit('createCouleurstraf', {
          ...payload,
          id: key.id
        })
      })
      .catch((error) => {
        console.log(error)
      })
  // Reach out to firebase and store it
  },
  deleteCouleurstrafData ({commit}, payload) {
    commit('setLoading', true)
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('couleurstrafen').doc(payload).delete()
    .then(() => {
      commit('setLoading', false)
      commit('deleteCouleurstraf', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
    commit('setLoading', false)
  },
  updateCouleurstrafData ({commit}, payload) {
    commit('setLoading', true)
    const updateObj = {}
    Object.keys(payload).forEach(key => {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key]
      }
    })
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('couleurstrafen').doc(payload.id).update(updateObj)
    .then(() => {
      commit('setLoading', false)
      commit('updateCouleurstraf', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
  }
}

// mutations
const mutations = {
  setLoadedCouleurstrafen (state, payload) {
    state.couleurstrafen = payload
  },
  createCouleurstraf (state, payload) {
    state.couleurstrafen.push(payload)
  },
  updateCouleurstraf (state, payload) {
    const couleurstraf = state.couleurstrafen.find(couleurstraf => {
      return couleurstraf.id === payload.id
    })
    Object.keys(payload).forEach(key => {
      if (payload[key]) {
        couleurstraf[key] = payload[key]
      }
    })
  },
  deleteCouleurstraf (state, payload) {
    let array = state.couleurstrafen
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1)
      }
    }
    state.couleurstrafen = array
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setError (state, payload) {
    state.error = payload
  },
  clearError (state) {
    state.error = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/couleurstrafen_alt.js